/**
 * Get edges and center points of an object
 * @param {fabric.Object} object - The fabric object
 * @returns {Object} Object containing edge and center positions
 */
export const getObjectSnapPoints = (object) => {
  const bounds = object.getBoundingRect();
  const center = object.getCenterPoint();

  return {
    left: bounds.left,
    right: bounds.left + bounds.width,
    top: bounds.top,
    bottom: bounds.top + bounds.height,
    centerX: center.x,
    centerY: center.y,
    width: bounds.width,
    height: bounds.height,
  };
};
